import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { Stars as StarsIcon } from "@mui/icons-material";

interface SuperAdminBadgeProps {
  size?: "small" | "medium";
}

/**
 * Badge to indicate a superadmin user
 * Shows star icon with tooltip
 */
export const SuperAdminBadge: React.FC<SuperAdminBadgeProps> = ({
  size = "small",
}) => {
  return (
    <Tooltip title="Pääkäyttäjä - Täydet oikeudet järjestelmään">
      <Chip
        icon={<StarsIcon />}
        label="Pääkäyttäjä"
        size={size}
        color="primary"
        variant="filled"
      />
    </Tooltip>
  );
};
